import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import WrappedExperience from '../components/wrapped/WrappedExperience';
import { WrappedStats } from '../components/wrapped/types';
import SeoMeta from '../components/SeoMeta';
import '../components/wrapped/wrapped.css';

const CandidaturasWrapped: React.FC = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState<WrappedStats | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data, error: err } = await supabase.schema('premios').rpc('get_public_stats');
      if (cancelled) return;
      if (err || !data) {
        console.error('Error cargando estadísticas públicas:', err);
        setError(true);
        return;
      }
      setStats(data as WrappedStats);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="wrapped-root">
        <div className="wrapped-error">
          <h2 className="wrapped-title" style={{ fontSize: 26 }}>No hemos podido cargar los datos</h2>
          <p className="wrapped-sub">Inténtalo de nuevo en unos instantes.</p>
          <button className="wrapped-btn primary" onClick={() => navigate('/')} type="button">
            Volver a la web
          </button>
        </div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="wrapped-root">
        <div className="wrapped-loading">
          <div className="wrapped-spinner" />
          <p className="wrapped-sub">Preparando el resumen…</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SeoMeta
        title="Candidaturas 2026 · Premios NovaGob a la Innovación Pública"
        description="Descubre en cifras las candidaturas presentadas a los Premios NovaGob Excelencia 2026: proyectos e iniciativas de innovación pública y transformación digital de administraciones de España y Latinoamérica."
        path="/candidaturas"
      />
      <WrappedExperience stats={stats} />
    </>
  );
};

export default CandidaturasWrapped;
